export default "__VITE_ASSET__DHxDBDqS__"